<div class="ai-dual-list">
    @if (disabled()) {
        <div class="ai-dual-list__overlay"></div>
    }

    <!-- Painel: disponíveis -->
    <div class="ai-dual-list__panel">
        <div class="ai-dual-list__header">
            <span class="ai-dual-list__title">{{ labelAvailable() }}</span>
            <span class="ai-dual-list__count">{{ availableCount() }}</span>
        </div>
        <div
            class="ai-dual-list__list"
            role="listbox"
            aria-multiselectable="true"
            tabindex="0"
            [attr.aria-activedescendant]="
                activeIndex('available') >= 0
                    ? 'dls-a-' + activeIndex('available')
                    : null
            "
            (keydown)="onPanelKeydown('available', $event)"
        >
            @for (row of visibleAvailableItems(); track row[0].id; let i = $index) {
                <div
                    class="ai-dual-list__item"
                    [id]="'dls-a-' + i"
                    role="option"
                    [attr.aria-selected]="row[0].value.isSelected"
                    [ngClass]="{
                        'ai-is-active': row[0].value.isSelected,
                        'ai-is-focused': i === activeIndex('available')
                    }"
                    [@dualListItem]
                    (click)="onSelectItem(row[0])"
                    (dblclick)="onDoubleClickItem(row[0])"
                >
                    <ng-container
                        [ngTemplateOutlet]="itemTemplate() ?? defaultItemTemplate"
                        [ngTemplateOutletContext]="{
                            $implicit: row[0].value.item,
                            item: row[0].value.item,
                            list: 'available',
                            highlight: highlightSegments(
                                row[0].value.item.name,
                                'available'
                            )
                        }"
                    ></ng-container>
                </div>
            } @empty {
                <div class="ai-dual-list__empty">
                    <ai-icon
                        class="ai-dual-list__empty-icon"
                        [fontIcon]="
                            availableEmpty() === 'allSelected'
                                ? 'fa-solid fa-circle-check'
                                : 'fa-regular fa-folder-open'
                        "
                    />
                    <span class="ai-dual-list__empty-text">
                        {{
                            availableEmpty() === 'allSelected'
                                ? allSelectedText()
                                : noItemsText()
                        }}
                    </span>
                </div>
            }
        </div>
    </div>

    <!-- Controles de movimentação -->
    <div class="ai-dual-list__controls">
        <div class="ai-dual-list__controls-buttons">
            <ai-button
                [shape]="'base-rounder'"
                [disabled]="disabled()"
                [type]="'button'"
                [tooltip]="'Remover todos'"
                (click)="onClickDoubleLeftArrow()"
            >
                <ai-icon [fontIcon]="'fa-solid fa-angles-left'" />
            </ai-button>
            <ai-button
                [shape]="'base-rounder'"
                [disabled]="disabled()"
                [type]="'button'"
                [tooltip]="'Remover'"
                (click)="onClickLeftArrow()"
            >
                <ai-icon [fontIcon]="'fa-solid fa-angle-left'" />
            </ai-button>
            <ai-button
                [shape]="'base-rounder'"
                [disabled]="disabled()"
                [type]="'button'"
                [tooltip]="'Incluir'"
                (click)="onClickRightArrow()"
            >
                <ai-icon [fontIcon]="'fa-solid fa-angle-right'" />
            </ai-button>
            <ai-button
                [shape]="'base-rounder'"
                [disabled]="disabled()"
                [type]="'button'"
                [tooltip]="'Incluir todos'"
                (click)="onClickDoubleRightArrow()"
            >
                <ai-icon [fontIcon]="'fa-solid fa-angles-right'" />
            </ai-button>
        </div>
    </div>

    <!-- Painel: selecionados -->
    <div class="ai-dual-list__panel">
        <div class="ai-dual-list__header">
            @if (required()) {
                <span class="ai-dual-list__title" aiRequiredFieldLabel>{{ labelSelected() }}</span>
            } @else {
                <span class="ai-dual-list__title">{{ labelSelected() }}</span>
            }
            <span class="ai-dual-list__count">{{ selectedCount() }}</span>
        </div>
        <div
            class="ai-dual-list__list"
            role="listbox"
            aria-multiselectable="true"
            tabindex="0"
            [attr.aria-activedescendant]="
                activeIndex('selected') >= 0
                    ? 'dls-s-' + activeIndex('selected')
                    : null
            "
            (keydown)="onPanelKeydown('selected', $event)"
        >
            @for (row of visibleSelectedItems(); track row[0].id; let i = $index) {
                <div
                    class="ai-dual-list__item"
                    [id]="'dls-s-' + i"
                    role="option"
                    [attr.aria-selected]="row[0].value.isSelected"
                    [ngClass]="{
                        'ai-is-active': row[0].value.isSelected,
                        'ai-is-focused': i === activeIndex('selected')
                    }"
                    [@dualListItem]
                    (click)="onSelectItem(row[0])"
                    (dblclick)="onDoubleClickItem(row[0])"
                >
                    <ng-container
                        [ngTemplateOutlet]="itemTemplate() ?? defaultItemTemplate"
                        [ngTemplateOutletContext]="{
                            $implicit: row[0].value.item,
                            item: row[0].value.item,
                            list: 'selected',
                            highlight: highlightSegments(
                                row[0].value.item.name,
                                'selected'
                            )
                        }"
                    ></ng-container>
                </div>
            } @empty {
                <div class="ai-dual-list__empty">
                    <ai-icon
                        class="ai-dual-list__empty-icon"
                        [fontIcon]="
                            selectedEmpty() === 'selectNone'
                                ? 'fa-solid fa-hourglass-half'
                                : 'fa-regular fa-folder-open'
                        "
                    />
                    <span class="ai-dual-list__empty-text">
                        {{
                            selectedEmpty() === 'selectNone'
                                ? selectHintText()
                                : noItemsText()
                        }}
                    </span>
                </div>
            }
        </div>
    </div>
</div>

<!--
    Template padrão de item: o nome do item com o trecho buscado realçado.
    Reproduz o formato anterior à introdução de `[itemTemplate]`.
-->
<ng-template #defaultItemTemplate let-highlight="highlight">
    @for (seg of highlight; track $index) {
        <span [class.ai-dual-list__hl]="seg.match">{{ seg.text }}</span>
    }
</ng-template>
